"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _PageHeading = _interopRequireDefault(require("../components/PageHeading"));
var _Paragraph = _interopRequireDefault(require("../components/Paragraph"));
var _RicePaper = _interopRequireDefault(require("../components/RicePaper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EKSRedirect = _ref => {
  let {
    name
  } = _ref;
  const location = (0, _reactRouterDom.useLocation)();
  const href = 'https://www.edwardskarateschool.com' + location.pathname;
  window.location.replace(href);
  return /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, /*#__PURE__*/_react.default.createElement(_PageHeading.default, {
    title: "Page Moved"
  }), /*#__PURE__*/_react.default.createElement(_RicePaper.default, {
    sx: {
      maxWidth: 'sm',
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    paragraph: true
  }, "You are being sent to another page,", ' ', /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: href
  }, /*#__PURE__*/_react.default.createElement("b", null, name || 'Edwards Karate School')), ".")));
};
EKSRedirect.defaultProps = {};
EKSRedirect.propTypes = {
  name: _propTypes.default.string
};
var _default = exports.default = EKSRedirect;